import Navbar from "./components/Navbar/Navbar";
import Intro from "./components/Intro/Intro";
import Camera from "./components/Camera/Camera";
import "./App.css";
import Brands from "./components/Brands/Brands";
import Works from "./components/Works/Works";
import Review from "./components/Review/Review";
import Testimonial from "./components/Testimonials/Testimonial";
import Contact from "./components/Contact/Contact";
import Footer from "./components/Footer/Footer";
import { useContext } from "react";
import { themeContext } from "./Context";
function App() {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;
  return (
    <div
      className="App"
      style={{
        background: darkMode ? "black" : "",
        color: darkMode ? "white" : "",
      }}
    >
      <Navbar />
      <Intro />
      <Camera />
      <Brands />
      <Works />
      <Review />
      <Testimonial />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
